module.exports = __webpack_public_path__ + "static/media/coop-kurs.e37d91f9.jpg";